import * as state from '@/components/Analysis/state';
import { primary } from '@/theme/colors';
import { GroupByResult, PointOfInterestGroupBy } from '@/types';
import CreateNewFolderIcon from '@mui/icons-material/CreateNewFolder';
import { Box, Button } from '@mui/material';
import { useAtomValue } from 'jotai';
import { useState } from 'react';
import { CreateReportModal } from './CreateReportModal';

export const AddToReportButton = ({
  groupedPois,
}: {
  groupedPois: GroupByResult<PointOfInterestGroupBy>;
}) => {
  const [createReportModalOpen, setCreateReportModalOpen] = useState(false);
  const allTemplates = useAtomValue(state.allPointOfInterestTemplates);

  const handleOpen = () => setCreateReportModalOpen(true);
  const handleClose = () => setCreateReportModalOpen(false);

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        bgcolor: 'white',
      }}
    >
      <Button
        variant="contained"
        onClick={handleOpen}
        sx={{
          maxHeight: '4.4rem',
          width: '100%',
          backgroundColor: primary.darkBlue,
          borderRadius: '0.2rem',
          textTransform: 'none',
          fontSize: '1.5rem',
          '@media (max-width: 1728px)': {
            height: '3.2rem',
          },
        }}
      >
        <CreateNewFolderIcon sx={{ mr: 2 }} />
        Add to Report
      </Button>
      <CreateReportModal
        title="Select relevant points of interest and create your report"
        open={createReportModalOpen}
        pointOfInterestTemplates={allTemplates}
        groupedPointOfInterests={groupedPois}
        handleClose={handleClose}
      />
    </Box>
  );
};
